import { MonitoredOperationListItemResponse } from '@6grain/masofa-monolith-api-client/common/model/monitoredOperationListItemResponse';
import { assignmentRowTitle, namedKeyLabel } from '@app/pages/admin/orchestration-identity.util';
import {
  AssignmentResultFilter,
  formatAssignmentResultTooltip,
  readAssignmentResultCount,
} from '@app/pages/admin/assignment-result-count.util';
import {
  AssignmentStateFilter,
  TagSeverity,
  assignmentStateSeverity,
} from '@app/pages/admin/orchestration-process-page/orchestration-process-page.util';
import {
  parseAssignmentTableFilterQuery,
  serializeAssignmentTableFilterQuery,
} from '@app/pages/admin/assignment-table-filter-query.util';
import { formatAssignmentDuration } from '@app/pages/admin/assignment-duration.util';
import { assignmentOutcome } from '@app/pages/admin/assignment-execution.util';
import { assignmentStatusAt } from '@app/pages/admin/assignment-status-at.util';
import { assignmentHostLabel, readAssignmentHost, readAssignmentWorker } from '@app/pages/admin/assignment-host.util';
import { AssignmentRssView, readAssignmentRss } from '@app/pages/admin/assignment-rss';

export interface SubscriptionAssignmentTableFilters {
  result: AssignmentResultFilter;
  state: AssignmentStateFilter;
  createdRange: Date[] | null;
}

export const parseSubscriptionAssignmentFilterQuery = parseAssignmentTableFilterQuery;
export const serializeSubscriptionAssignmentFilterQuery = serializeAssignmentTableFilterQuery;

export interface SubscriptionAssignmentRow {
  id: string;
  name: string;
  processKey: string;
  processLabel: string;
  state: string;
  stateLabel: string;
  skipped: boolean;
  stateSeverity: TagSeverity;
  statusAt: string | null;
  createdAt?: string;
  progressLabel: string;
  durationLabel: string;
  hostLabel: string;
  workerId: string | null;
  workerServiceName: string | null;
  workerHostName: string | null;
  workerVersion: string | null;
  resultCount: number | null;
  resultTooltip: string | null;
  rss: AssignmentRssView | null;
  error: string | null;
}

export function toSubscriptionAssignmentRow(
  item: MonitoredOperationListItemResponse,
  processes?: Array<{ key: string; displayName?: string }> | null,
): SubscriptionAssignmentRow {
  const processKey = item.operationType?.trim() || '';
  const outcome = assignmentOutcome({ ...item, operationType: processKey });
  return {
    id: item.id ?? '',
    name: assignmentRowTitle(item.name, processKey, processes),
    processKey,
    processLabel: namedKeyLabel(processes, processKey) || processKey || '—',
    state: item.state ?? '—',
    stateLabel: outcome.skipped ? outcome.label : (item.state ?? '—'),
    skipped: outcome.skipped,
    stateSeverity: outcome.skipped ? 'secondary' : assignmentStateSeverity(item.state),
    statusAt: assignmentStatusAt(item.state, item.startedAt, item.completedAt),
    createdAt: item.createdAt,
    progressLabel: `${item.progressPercentage ?? 0}%`,
    durationLabel: formatAssignmentDuration(item.durationSeconds),
    hostLabel: assignmentHostLabel({
      kind: item.kind,
      startedAt: item.startedAt,
      ...readAssignmentHost(item),
    }),
    ...readAssignmentWorker(item),
    resultCount: readAssignmentResultCount(item),
    resultTooltip: formatAssignmentResultTooltip(item),
    rss: readAssignmentRss(item),
    error: item.error ?? null,
  };
}
